import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import W from '../styled/Wrapper';
import H from '../styled/Heading';
import RichText from './RichText';

import Video from './Video';

import ImageItem from '../shared/ImageItem';

const Wrapper = styled(W)`
  display: flex;
  padding-bottom: 100px;
  justify-content: center;
  align-items: ${({ textPos }) => {
    if (textPos) {
      if (textPos === 'top') {
        return 'flex-start';
      } else if (textPos === 'bottom') {
        return 'flex-end';
      } else {
        return 'center';
      }
    } else {
      return 'center';
    }
  }};

  @media only screen and (max-width: 810px) {
    flex-direction: column;
    padding-bottom: 14px;
    justify-content: center;
    align-items: center;
  }
`;

const AssetWrapper = styled.div`
  padding: ${({ right }) => (right ? '0 30px 0 70px' : '0 70px 0 30px')};
  height: ${({ vid, vidPortrait }) => (vid && vidPortrait ? '75vh' : 'auto')};
  width: ${({ vid, portrait, portraitRatio }) =>
    vid ? '50%' : portrait ? (portraitRatio > 1.25 ? '30%' : '40%') : '50%'};
  overflow: hidden;
  object-fit: contain;

  & > div {
    height: ${({ vid }) => (vid ? '100%' : 'auto')};
  }

  img,
  video {
    object-fit: contain !important;
    height: 100%;
  }

  img:first-of-type {
    object-fit: cover !important;
  }

  .graphcms-image-wrapper,
  .graphcms-image-outer-wrapper {
    object-fit: contain;
    height: 100%;
  }

  @media only screen and (max-width: 810px) {
    width: 100%;
    padding: 0;
    height: auto;
    margin-bottom: 20px;
  }
`;

const TextWrapper = styled.div`
  width: 50%;
  max-width: 560px;
  /* padding: 20px 0 20px; */
  order: ${({ left }) => (left ? -1 : 'auto')};

  padding: ${({ textPos }) => {
    if (textPos) {
      if (textPos === 'top') {
        return '0 0 20px';
      } else if (textPos === 'bottom') {
        return '20px 0 0';
      } else {
        return '20px 0 20px';
      }
    } else {
      return '20px 0 20px';
    }
  }};

  @media only screen and (max-width: 810px) {
    order: -1;
    width: 100%;
    padding: 0;
  }
`;

const Heading = styled(H)`
  margin-bottom: 20px;

  @media only screen and (max-width: 810px) {
    font-size: 36px;
    line-height: 43px;
    margin-bottom: 10px;
  }
`;

const Paragraph = styled.div`
  @media only screen and (max-width: 810px) {
    margin-bottom: 14px;
  }
`;

const ImgText = ({ data, locs }) => {
  const [vidPortrait, setVidPortrait] = useState(false);
  const el = useRef(null);

  useEffect(() => {
    if (el.current) {
      const vid = el.current.querySelector('video');

      if (vid)
        vid.addEventListener('canplay', () => {
          if (vid.offsetHeight / vid.offsetWidth >= 1) {
            setVidPortrait(true);
          }
        });

      return () => {
        if (vid)
          vid.removeEventListener('canplay', () => {
            if (vid.offsetHeight / vid.offsetWidth >= 1) {
              setVidPortrait(true);
            }
          });
      };
    }
  }, []);

  return (
    <Wrapper ref={el} textPos={data.textPosition}>
      {locs
        ? locs.imageItem && (
            <AssetWrapper
              right={data.imageOnTheRight}
              portrait={
                locs.imageItem.image &&
                locs.imageItem.image.height / locs.imageItem.image.width >= 1
              }
              portraitRatio={
                locs.imageItem.image &&
                locs.imageItem.image.height / locs.imageItem.image.width
              }
              vid={locs.imageItem.videoUrl}
              vidPortrait={vidPortrait}
            >
              {locs.imageItem.videoUrl ? (
                <Video
                  loop={locs.imageItem.loop}
                  loopWithSound={locs.imageItem.loopWithSound}
                  video={locs.imageItem.videoUrl}
                  poster={locs.imageItem.image}
                />
              ) : (
                <ImageItem image={locs.imageItem.image} />
              )}
            </AssetWrapper>
          )
        : data.imageItem && (
            <AssetWrapper
              right={data.imageOnTheRight}
              portrait={
                data.imageItem.image &&
                data.imageItem.image.height / data.imageItem.image.width >= 1
              }
              portraitRatio={
                data.imageItem.image &&
                data.imageItem.image.height / data.imageItem.image.width
              }
              vid={data.imageItem.videoUrl}
              vidPortrait={vidPortrait}
            >
              {data.imageItem.videoUrl ? (
                <Video
                  loop={data.imageItem.loop}
                  video={data.imageItem.videoUrl}
                  loopWithSound={data.imageItem.loopWithSound}
                  poster={data.imageItem.image}
                />
              ) : (
                <ImageItem image={data.imageItem.image} />
              )}
            </AssetWrapper>
          )}

      <TextWrapper left={data.imageOnTheRight} textPos={data.textPosition}>
        {data.heading && <Heading size={3}>{data.heading}</Heading>}
        {data.text && (
          <Paragraph firstParMargin>
            <RichText content={data.text.raw} noMarBottom={data.textPosition === 'bottom'} />
          </Paragraph>
        )}
      </TextWrapper>
    </Wrapper>
  );
};

export default ImgText;
